<form [formGroup]="form">
  <div class="pb-lg gap-lg flex flex-col">
    <div hlmField>
      <label for="aptitude" hlmFieldLabel labelRequired>Nom de l'aptitude </label>
      <input id="aptitude" hlmInput formControlName="nom" />
      @if (nom.hasError('required') && nom.touched) {
        <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
      }
      @if (nom.hasError('notUnique')) {
        <hlm-field-error>Cette aptitude existe déjà.</hlm-field-error>
      }
    </div>

    <div hlmField>
      <label for="select-phases" hlmFieldLabel>Rattaché à</label>
      <hlm-select id="'select-phases" formControlName="phase">
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>

        <hlm-select-content>
          @for (phase of phases(); track phase.id) {
            <hlm-option [value]="phase">
              {{ phase.nom }}
            </hlm-option>
          }
        </hlm-select-content>
      </hlm-select>
    </div>
  </div>
</form>
